import { Action } from '@ngrx/store';
import { CopyAppPayload } from '../../_models/settings.models';

/**
 * Application User action types
 */
export enum CopyAppsTypes {
  LOAD_COPY_APPS = '[Copy Apps] Load Copy Apps',
  LOAD_COPY_APPS_SUCCESS = '[Copy Apps] Load Copy Apps Success',
  LOAD_COPY_APPS_FAILED = '[Copy Apps] Load Copy Apps Failed',
  CREATE_COPY_APP = '[Copy Apps] Create Copy App',
  CREATE_COPY_APP_SUCCESS = '[Copy Apps] Create Copy App Success',
  CREATE_COPY_APP_FAILED = '[Copy Apps] Create Copy App Failed',
  DELETE_COPY_APP = '[Copy Apps] Delete Copy App',
  DELETE_COPY_APP_SUCCESS = '[Copy Apps] Delete Copy App Success',
  DELETE_COPY_APP_FAILED = '[Copy Apps] Delete Copy App Failed',
  RESET = '[Copy Apps] Reset',
}

/**
 * Operations
 */
export class LoadCopyApps implements Action {
  readonly type = CopyAppsTypes.LOAD_COPY_APPS;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public appId: string, public force: boolean = false) {}
}

export class LoadCopyAppsSuccess implements Action {
  readonly type = CopyAppsTypes.LOAD_COPY_APPS_SUCCESS;

  constructor(public appId: string, public payload: any) {}
}

export class LoadCopyAppsFailed implements Action {
  readonly type = CopyAppsTypes.LOAD_COPY_APPS_FAILED;

  constructor(public payload: any) {}
}

export class CreateCopyApp implements Action {
  readonly type = CopyAppsTypes.CREATE_COPY_APP;

  constructor(public appId: string, public payload: CopyAppPayload) {}
}

export class CreateCopyAppSuccess implements Action {
  readonly type = CopyAppsTypes.CREATE_COPY_APP_SUCCESS;

  constructor(public appId: string, public payload: any) {}
}

export class CreateCopyAppFailed implements Action {
  readonly type = CopyAppsTypes.CREATE_COPY_APP_FAILED;

  constructor(public payload: any) {}
}

export class DeleteCopyApp implements Action {
  readonly type = CopyAppsTypes.DELETE_COPY_APP;

  constructor(public appKey: string, public copyAppKey: string) {}
}

export class DeleteCopyAppSuccess implements Action {
  readonly type = CopyAppsTypes.DELETE_COPY_APP_SUCCESS;

  constructor(public appId: string, public copyAppId: string) {}
}

export class DeleteCopyAppFailed implements Action {
  readonly type = CopyAppsTypes.DELETE_COPY_APP_FAILED;

  constructor(public payload: any) {}
}

export class Reset implements Action {
  readonly type = CopyAppsTypes.RESET;

  constructor() {}
}

/**
 * Available types
 */
export type Actions =
  | LoadCopyApps
  | LoadCopyAppsSuccess
  | LoadCopyAppsFailed
  | CreateCopyApp
  | CreateCopyAppSuccess
  | CreateCopyAppFailed
  | DeleteCopyApp
  | DeleteCopyAppSuccess
  | DeleteCopyAppFailed
  | Reset;
